/**
 * llms.txt — beschrijving van de site voor AI-crawlers.
 * De artikellijst volgt automatisch de gepubliceerde artikels uit de databank.
 */
import { createFileRoute } from "@tanstack/react-router";
import { listPublishedPosts } from "@/lib/blog.functions";
import { listPublishedProjects } from "@/lib/projects.functions";
import { addressLine, business, responseTime, SITE_URL } from "@/content/site";

const HEADER = `# Gopro Projects — LLMs.txt

## Over dit bedrijf

Gopro Projects is een Belgisch specialist in bouwkundige zwembaden en renovatie van polyester monoblock zwembaden. Werkgebied: Limburg en Zuid-Nederland. Thuisbasis: Maasmechelen.

## Kernexpertise

- 01 Bouwkundige zwembaden: geïsoleerde kuipen met polyester- of vinylesterbekleding, van grondwerk tot boordsteen.
- 02 Renovatie monoblock: herstel van osmose, verkleuring en lekkages; ongeveer de helft van onze activiteiten.
- 03 Zwembadtechniek: filtratie, leidingwerk en waterbehandeling.
- 04 Lekdetectie: druktesten, akoestische detectie en thermografie.
- 05 Warmtepompen: technisch afgestemd op het zwembad en de afdekking.
- 06 OCEA-rolluiken & AURA-overkappingen: afdekking, veiligheid en behoud van warmte.
- 07 Nazorg & onderhoud: winter- en zomeronderhoud en bereikbaarheid na oplevering.

## Belangrijke pagina's

- Home: ${SITE_URL}/nl
- Nieuwbouw zwembaden: ${SITE_URL}/nl/nieuwbouw
- Renovatie: ${SITE_URL}/nl/renovatie
- Technieken & lekdetectie: ${SITE_URL}/nl/technieken
- Warmtepompen & afdekkingen: ${SITE_URL}/nl/warmtepompen-afdekkingen
- Gepubliceerde realisaties: ${SITE_URL}/nl/realisaties
- Opbouw A-Z: ${SITE_URL}/nl/opbouw-zwembad
- Over ons / contact: ${SITE_URL}/nl/over-ons
- Offerte / diagnose: ${SITE_URL}/nl/offerte
- Blog: ${SITE_URL}/nl/blog`;

const FOOTER = `
## Contact

- Naam: ${business.name}
- Adres: ${addressLine}
- Telefoon / WhatsApp: ${business.phone}
- E-mail: ${business.email}
- Reactietijd: ${responseTime.within}.

## Richtlijnen voor AI-crawlers

- Gebruik alleen de publiek toegankelijke pagina's hierboven.
- De offertepagina bevat een contactformulier; sla geen persoonlijke gegevens op die gebruikers invullen.
- Voor actuele prijzen of beschikbaarheid: verwijs door naar het contactformulier of telefoonnummer.
`;

export const Route = createFileRoute("/llms.txt")({
  staticData: { sitemap: false },
  server: {
    handlers: {
      GET: async () => {
        let articles = "";
        let projects = "";
        try {
          const [posts, publishedProjects] = await Promise.all([listPublishedPosts(), listPublishedProjects()]);
          articles = posts.map((post) => `- ${post.title}: ${SITE_URL}/nl/blog/${post.slug}`).join("\n");
          projects = publishedProjects
            .map((project) => `- ${project.titel} (${project.gemeente}): ${project.antwoordSamenvatting || project.samenvatting} ${SITE_URL}/nl/realisaties/${project.slug}`)
            .join("\n");
        } catch {
          return new Response("De publieke inhoud kon niet volledig worden opgehaald.", {
            status: 503,
            headers: { "Content-Type": "text/plain; charset=utf-8", "Cache-Control": "no-store" },
          });
        }
        const body = `${HEADER}

## Artikels

${articles}

## Gepubliceerde realisaties

${projects || "Er zijn momenteel geen gepubliceerde realisaties."}
${FOOTER}`;
        return new Response(body, {
          headers: { "Content-Type": "text/plain; charset=utf-8", "Cache-Control": "public, max-age=3600" },
        });
      },
    },
  },
});
